import { oauthTokenSelector } from 'selectors/app'

import integrationApi from '../../api'

import {
  FETCH_CREATE_ISSUE_META_ISSUE_TYPE_FIELDS_REQUEST,
  FETCH_CREATE_ISSUE_META_ISSUE_TYPE_FIELDS_SUCCESS,
  FETCH_CREATE_ISSUE_META_ISSUE_TYPE_FIELDS_ERROR,
} from '../types'

// get supported JIRA fields for project + issue type combination
// because sometimes some optional fields like priority, labels etc could be disabled on a JIRA project
// and JIRA throws us an error if we try to send to send that in the create issue POST
export default function doFetchJiraCloudCreateIssueMetaTypeFields(
  cloudId,
  projectId
) {
  return async (dispatch, getState) => {
    const meta = { cloudId, projectId }

    // Early parameter validation
    if (!cloudId) {
      const error = new Error(
        'cloudId is required for fetching Jira Cloud create issue metadata'
      )
      dispatch({
        type: FETCH_CREATE_ISSUE_META_ISSUE_TYPE_FIELDS_ERROR,
        error: true,
        meta,
        payload: error,
      })
      return
    }

    if (!projectId) {
      const error = new Error(
        'projectId is required for fetching Jira Cloud create issue metadata'
      )
      dispatch({
        type: FETCH_CREATE_ISSUE_META_ISSUE_TYPE_FIELDS_ERROR,
        error: true,
        meta,
        payload: error,
      })
      return
    }

    const token = oauthTokenSelector(getState())
    if (!token) {
      const error = new Error(
        'OAuth token is required for fetching Jira Cloud create issue metadata'
      )
      dispatch({
        type: FETCH_CREATE_ISSUE_META_ISSUE_TYPE_FIELDS_ERROR,
        error: true,
        meta,
        payload: error,
      })
      return
    }

    dispatch({
      type: FETCH_CREATE_ISSUE_META_ISSUE_TYPE_FIELDS_REQUEST,
      meta,
    })

    try {
      // First, get all issue types for the project
      const issueTypesResponse = await integrationApi.get(
        token,
        `proxy/atlassian/ex/jira/${cloudId}/rest/api/3/issue/createmeta/${projectId}/issuetypes`
      )

      // Validate response structure and content
      if (!issueTypesResponse.json) {
        throw new Error(
          'Invalid response format: missing JSON data from Jira Cloud issue types endpoint'
        )
      }

      const { issuetypes } = issueTypesResponse.json
      if (!issuetypes) {
        throw new Error(
          'Invalid response format: missing issuetypes property from Jira Cloud'
        )
      }

      if (!Array.isArray(issuetypes)) {
        throw new Error('Invalid response format: issuetypes must be an array')
      }

      if (issuetypes.length === 0) {
        throw new Error('No issue types available for this project')
      }

      // Then, fetch fields for each issue type
      const issueTypesWithFields = await Promise.all(
        issuetypes.map(async issueType => {
          const fieldsResponse = await integrationApi.get(
            token,
            `proxy/atlassian/ex/jira/${cloudId}/rest/api/3/issue/createmeta/${projectId}/issuetypes/${
              issueType.id
            }`
          )

          return {
            ...issueType,
            fields: fieldsResponse.json?.fields || {},
          }
        })
      )

      // Format the response to match the old createmeta format
      const payload = {
        projects: [
          {
            id: projectId,
            issuetypes: issueTypesWithFields,
          },
        ],
      }

      dispatch({
        type: FETCH_CREATE_ISSUE_META_ISSUE_TYPE_FIELDS_SUCCESS,
        meta,
        payload,
      })
    } catch (error) {
      dispatch({
        type: FETCH_CREATE_ISSUE_META_ISSUE_TYPE_FIELDS_ERROR,
        error: true,
        meta,
        payload: error,
      })
    }
  }
}
